export const SALESFORCE_CALENDAR = [
  { value: 'BRAINHI', label: 'BrainHi (no calendar)' },
  { value: 'AMAZING_CHARTS', label: 'Amazing Charts' },
  { value: 'PROCLAIM', label: 'Assertus (ProClaim)' },
  { value: 'ATHENA', label: 'Athena' },
  { value: 'CHIROTOUCH', label: 'ChiroTouch' },
  { value: 'CLINIC_CLOUD', label: 'Clinic Cloud' },
  { value: 'CURVE_HERO', label: 'Curve Hero' },
  { value: 'CUSTOM', label: 'Custom made' },
  { value: 'DENTALMAX', label: 'DentalMax' },
  { value: 'DENTALVISION', label: 'DentalVision' },
  { value: 'DENTRIX', label: 'Dentrix' },
  { value: 'DENTRIX_ASCEND', label: 'Dentrix Ascend' },
  { value: 'DR_CHRONO', label: 'Dr. Chrono' },
  { value: 'EHRZ', label: 'EHRz' },
  { value: 'EAGLESOFT', label: 'EagleSoft' },
  { value: 'ECLIPSE', label: 'Eclipse' },
  { value: 'EVOLUTION', label: 'Evolution' },
  { value: 'EXCEL', label: 'Excel' },
  { value: 'FIRST_COME_FIRST_SERVE', label: 'First come, first serve' },
  { value: 'GOOGLE_CALENDAR', label: 'Google Calendar' },
  { value: 'SECURECLAIM', label: 'Inmediata (SecureClaim)' },
  { value: 'MOGO', label: 'MOGO' },
  { value: 'MANUALLY', label: 'Manually (Paper)' },
  { value: 'MEDIREC', label: 'MediRec' },
  { value: 'NEOMED', label: 'NeoMed' },
  { value: 'OFFICEALLY', label: 'OfficeAlly' },
  { value: 'OPEN_DENTAL', label: 'Open Dental' },
  { value: 'ORTHOCHART', label: 'OrthoChart' },
  { value: 'OTHER', label: 'Other' },
  { value: 'OUTLOOK', label: 'Outlook' },
  { value: 'PLATINUM_SYSTEM', label: 'Platinum System' },
  { value: 'PRACTICE_FUSION', label: 'Practice Fusion' },
  { value: 'PROGNOSIS', label: 'Prognosis' },
  { value: 'PROLOGIC', label: 'Prologic' },
  { value: 'REMEDLY', label: 'Remedly' },
  { value: 'SOAPWARE', label: 'SOAPware' },
  { value: 'SETMORE', label: 'SetMore' },
  { value: 'CLINICALWORKS', label: 'eClinicalWorks' },
];

export const SALESFORCE_TOWN = [
  { value: 'ADJUNTAS', label: 'Adjuntas' },
  { value: 'AGUADA', label: 'Aguada' },
  { value: 'AGUADILLA', label: 'Aguadilla' },
  { value: 'AGUAS_BUENAS', label: 'Aguas Buenas' },
  { value: 'AIBONITO', label: 'Aibonito' },
  { value: 'ANASCO', label: 'Anasco' },
  { value: 'ARECIBO', label: 'Arecibo' },
  { value: 'ARROYO', label: 'Arroyo' },
  { value: 'BARCELONETA', label: 'Barceloneta' },
  { value: 'BARRANQUITAS', label: 'Barranquitas' },
  { value: 'BAYAMON', label: 'Bayamon' },
  { value: 'CABO_ROJO', label: 'Cabo Rojo' },
  { value: 'CAGUAS', label: 'Caguas' },
  { value: 'CAMUY', label: 'Camuy' },
  { value: 'CANOVANAS', label: 'Canovanas' },
  { value: 'CAROLINA', label: 'Carolina' },
  { value: 'CATANO', label: 'Catano' },
  { value: 'CAYEY', label: 'Cayey' },
  { value: 'CEIBA', label: 'Ceiba' },
  { value: 'CIALES', label: 'Ciales' },
  { value: 'CIDRA', label: 'Cidra' },
  { value: 'COAMO', label: 'Coamo' },
  { value: 'COMERIO', label: 'Comerio' },
  { value: 'COROZAL', label: 'Corozal' },
  { value: 'CULEBRA', label: 'Culebra' },
  { value: 'DORADO', label: 'Dorado' },
  { value: 'FAJARDO', label: 'Fajardo' },
  { value: 'FLORIDA', label: 'Florida' },
  { value: 'GUANICA', label: 'Guanica' },
  { value: 'GUAYAMA', label: 'Guayama' },
  { value: 'GUAYANILLA', label: 'Guayanilla' },
  { value: 'GUAYNABO', label: 'Guaynabo' },
  { value: 'GURABO', label: 'Gurabo' },
  { value: 'HATILLO', label: 'Hatillo' },
  { value: 'HORMIGUEROS', label: 'Hormigueros' },
  { value: 'HUMACAO', label: 'Humacao' },
  { value: 'ISABELA', label: 'Isabela' },
  { value: 'JAYUYA', label: 'Jayuya' },
  { value: 'JUANA_DIAZ', label: 'Juana Diaz' },
  { value: 'JUNCOS', label: 'Juncos' },
  { value: 'LAJAS', label: 'Lajas' },
  { value: 'LARES', label: 'Lares' },
  { value: 'LAS_MARIAS', label: 'Las Marias' },
  { value: 'LAS_PIEDRAS', label: 'Las Piedras' },
  { value: 'LOIZA', label: 'Loiza' },
  { value: 'LUQUILLO', label: 'Luquillo' },
  { value: 'MANATI', label: 'Manati' },
  { value: 'MARICAO', label: 'Maricao' },
  { value: 'MAUNABO', label: 'Maunabo' },
  { value: 'MAYAGUEZ', label: 'Mayaguez' },
  { value: 'MOCA', label: 'Moca' },
  { value: 'MOROVIS', label: 'Morovis' },
  { value: 'NAGUABO', label: 'Naguabo' },
  { value: 'NARANJITO', label: 'Naranjito' },
  { value: 'OROCOVIS', label: 'Orocovis' },
  { value: 'OTHER', label: 'Other' },
  { value: 'PATILLAS', label: 'Patillas' },
  { value: 'PENUELAS', label: 'Penuelas' },
  { value: 'PONCE', label: 'Ponce' },
  { value: 'QUEBRADILLAS', label: 'Quebradillas' },
  { value: 'RINCON', label: 'Rincon' },
  { value: 'RIO_GRANDE', label: 'Rio Grande' },
  { value: 'SABANA_GRANDE', label: 'Sabana Grande' },
  { value: 'SALINAS', label: 'Salinas' },
  { value: 'SAN_GERMAN', label: 'San German' },
  { value: 'SAN_JUAN', label: 'San Juan' },
  { value: 'SAN_LORENZO', label: 'San Lorenzo' },
  { value: 'SAN_SEBASTIAN', label: 'San Sebastian' },
  { value: 'SANTA_ISABEL', label: 'Santa Isabel' },
  { value: 'TOA_ALTA', label: 'Toa Alta' },
  { value: 'TOA_BAJA', label: 'Toa Baja' },
  { value: 'TRUJILLO_ALTO', label: 'Trujillo Alto' },
  { value: 'UTUADO', label: 'Utuado' },
  { value: 'VEGA_ALTA', label: 'Vega Alta' },
  { value: 'VEGA_BAJA', label: 'Vega Baja' },
  { value: 'VIEQUES', label: 'Vieques' },
  { value: 'VILLALBA', label: 'Villalba' },
  { value: 'YABUCOA', label: 'Yabucoa' },
  { value: 'YAUCO', label: 'Yauco' },
];

export const STEP = {
  CREATING_ACCOUNT: 0,
  PROVISIONING_BOT_NUMBER: 1,
  FINISHED: 2,
};

export enum Action {
  SET_STEP = 'SET_STEP',
}
